// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"style_modalBtn__1J5qm","modalIcon":"style_modalIcon__1yo7x","modalContent":"style_modalContent__3prC3"};